import PageHeader from "../components/PageHeader";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { Eyebrow, Button } from "../components/Bits";
import Editable from "../components/Editable";
import { AIMS, VALUES } from "../lib/content";

export default function AboutAims() {
  return (
    <div>
      <PageHeader label="About NEAD" titleLines={["Aims, purpose", "and values."]}
        intro="NEAD CIC, short for Northern Equality and Diversity, exists to strengthen communities, champion inclusion and create opportunity through community programmes, festivals, live music and youth provision across Cumbria." />

      <section className="container-x py-24 md:py-32">
        <div className="grid lg:grid-cols-[0.42fr_0.58fr] gap-10 lg:gap-16">
          <Reveal>
            <Eyebrow className="text-nead-pink">Our purpose</Eyebrow>
          </Reveal>
          <Reveal delay={0.05}>
            <Editable id="aims.purpose.heading" as="p" multiline className="font-display font-medium text-2xl sm:text-3xl lg:text-[2.4rem] leading-[1.25] tracking-tight text-nead-navy text-balance">
              We are a purpose-driven Community Interest Company using music, festivals, culture and
              a dedicated under-18s centre to build brighter communities across the North.
            </Editable>
            <Editable id="aims.purpose.body" as="p" multiline className="mt-6 text-nead-navy/65 text-lg leading-relaxed">
              Everything we do is designed to promote equality and inclusion, create opportunities
              for young people and deliver sustainable projects that generate lasting social value,
              with every surplus reinvested back into our communities.
            </Editable>
          </Reveal>
        </div>
      </section>

      <section className="bg-nead-mist">
        <div className="container-x py-24 md:py-32">
          <Reveal>
            <Eyebrow className="text-nead-pink">What we set out to do</Eyebrow>
            <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl tracking-tight text-nead-navy max-w-2xl">Our aims.</h2>
          </Reveal>
          <Stagger className="mt-14 grid md:grid-cols-2 gap-6">
            {AIMS.map((a) => (
              <StaggerItem key={a.n}>
                <div className="rounded-[1.5rem] bg-white border border-black/[0.07] p-8 h-full">
                  <span className="font-display font-bold text-4xl text-gradient">{a.n}</span>
                  <h3 className="mt-4 font-display font-bold text-xl text-nead-navy">{a.title}</h3>
                  <p className="mt-3 text-nead-navy/60 leading-relaxed text-[0.95rem]">{a.body}</p>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      <section className="container-x py-24 md:py-32">
        <Reveal>
          <Eyebrow className="text-nead-pink">What guides us</Eyebrow>
          <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl tracking-tight text-nead-navy max-w-2xl">Our core values.</h2>
        </Reveal>
        <Stagger className="mt-14 grid md:grid-cols-2 gap-6">
          {VALUES.map((v) => (
            <StaggerItem key={v.n}>
              <div className="rounded-[1.5rem] border border-black/[0.07] bg-white p-8 md:p-10 h-full">
                <div className="flex items-baseline gap-4">
                  <span className="font-display font-bold text-3xl text-gradient">{v.n}</span>
                  <h3 className="font-display font-bold text-2xl text-nead-navy">{v.title.replace(/\u00a0/g, " ")}</h3>
                </div>
                <p className="mt-4 text-nead-navy/60 leading-relaxed">{v.body}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <section className="container-x pb-24 md:pb-32">
        <Reveal>
          <div className="rounded-[1.75rem] grad-pink-cyan text-white p-10 md:p-14 text-center">
            <h2 className="font-display font-bold text-3xl sm:text-4xl tracking-tight">Want to be part of it?</h2>
            <p className="mt-4 text-white/85 max-w-xl mx-auto">From volunteering to partnerships and event support, there are many ways to get involved with NEAD CIC.</p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <Button to="/get-involved" variant="light" testId="aims-get-involved">Get involved</Button>
              <Button to="/partners" variant="light" testId="aims-partner">Work with us</Button>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
